<template>
  <v-overlay
    :opacity="opacity"
    :value="overlay"
    absolute
    class="overlay"
  >
    <div class="flex-container">
      <div class="top mb-0 mb-xs-10">
        <svg
          version="1.1"
          viewBox="0 0 800 800"
        ><g
          stroke-width="5"
          stroke="hsl(0, 0%, 100%)"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          transform="matrix(0.4694715627858904,-0.8829475928589271,0.8829475928589271,0.4694715627858904,-156.96766225792703,577.3904120292146)"
        ><path
          d="M164 164Q302 541 636 636 "
          marker-end="url(#SvgjsMarker3523)"
        /></g><defs><marker
          id="SvgjsMarker3523"
          markerWidth="4"
          markerHeight="4"
          refX="2"
          refY="2"
          viewBox="0 0 4 4"
          orient="auto"
        ><polygon
          points="0,4 0,0 4,2"
          fill="hsl(0, 0%, 100%)"
        /></marker></defs></svg>
      </div>
      <div class="text-center ma-1">
        <slot name="baseHelpMessage" />
        <AgrButton
          color="primary darken-1"
          @click="hasCompris"
        >
          J'ai compris
        </AgrButton>
      </div>
      <span class="bottom" />
    </div>
  </v-overlay>
</template>

<script>
import { AgrButton } from '@agrial/ui'

export default {
  name: 'HelpUserTypeContrat',
  components: { AgrButton },
  props: {
    displayValue: {
      type: String,
      default: ''
    },
    bottom: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      overlay: true,
      opacity: 0.85
    }
  },
  methods: {
    hasCompris () {
      this.overlay = !this.overlay
      this.$emit(this.displayValue)
    }
  }
}
</script>
<style lang="scss" scoped>
.overlay {
  z-index: 4 !important;
}
.v-overlay {
  height: 100%;
  &::v-deep {
    .v-overlay__content {
      height: 100%;
      width: 100%;
    }
  }
}
.flex-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
}

.top {
  position: relative;
  flex: 1;
  top: 10px;
}

.bottom {
  flex: 1;
}

svg {
  position: absolute;
  right: 60px;
  top: 10px;
  height: 200%;
}

@media only screen and (min-width: 1880px) {
  svg {
    position: absolute;
    right: 60px;
    top: -20px;
    height: 160%;
  }
}
</style>
